export const INSTITUTE_LOG = "Institute Logo";
export const IMAGE_CROPPER_TITLE = "Institute logo help your students to recognize you in marketplace";
export const UPLOAD_INSTITUTE_LOGO = "Upload Institute Logo";
export const INSTITUTE_DETAILS = "Institute Details";
export const CONTACT_DETAILS = "Contact Details";
export const SAVECHANGES_BTN_TEX = "Save Changes";
